import React from "react";
import { Sparkles, Check } from "lucide-react";
import { useHOH, STEP } from "../../context/StyleContext";

const LABELS = ["Occasion", "Photo", "Hair", "Outfit", "Extras", "Look", "Book", "Content", "Trending"];

export default function TopBar() {
  const { step, occasion, selectedHair, selectedOutfit } = useHOH();
  const current = step - 1; // exclude intro

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-black/[0.04]">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 font-heading text-xl font-bold text-black">
          <Sparkles className="w-5 h-5 text-hoh-rose" /> HOH&nbsp;AI
        </div>

        {step > STEP.INTRO && (
          <div className="hidden md:flex items-center gap-1.5" data-testid="step-progress">
            {LABELS.map((l, i) => {
              const done = i < current;
              const active = i === current;
              return (
                <div key={l} className="flex items-center gap-1.5">
                  <div className={`flex items-center gap-1 rounded-full px-2 py-1 transition-all ${active ? "bg-hoh-navy text-white" : done ? "text-hoh-rose" : "text-hoh-slate/40"}`}>
                    <span className={`w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-bold ${active ? "bg-white text-hoh-navy" : done ? "bg-hoh-rose/20" : "bg-black/5"}`}>
                      {done ? <Check className="w-2.5 h-2.5" /> : i + 1}
                    </span>
                    <span className="text-[10px] font-semibold uppercase tracking-wider hidden lg:inline">{l}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="flex items-center gap-2 text-xs">
          {occasion && <span className="rounded-full bg-hoh-blush px-3 py-1 text-hoh-navy font-medium" data-testid="summary-occasion">{occasion}</span>}
          {selectedHair && <span className="rounded-full bg-hoh-lavender px-3 py-1 text-hoh-navy font-medium hidden sm:inline">{selectedHair.name}</span>}
          {selectedOutfit && <span className="rounded-full bg-hoh-cream px-3 py-1 text-hoh-navy font-medium hidden md:inline">{selectedOutfit.title}</span>}
        </div>
      </div>
    </header>
  );
}
